import {
    Palette,
    RefreshCw,
    LayoutGrid,
    ShoppingBag,
    Search,
    Server,
} from "lucide-react";

const features = [
    {
        icon: Palette,
        title: "Custom Website Design",
        description:
            "Original designs shaped around your brand, your audience, and your goals — never templates.",
    },
    {
        icon: RefreshCw,
        title: "Website Redesigns",
        description:
            "Take an outdated site and transform it into a modern, fast, mobile-ready experience.",
    },
    {
        icon: LayoutGrid,
        title: "Landing Pages",
        description:
            "High-converting single-page sites purpose-built for launches, campaigns, and lead capture.",
    },
    {
        icon: ShoppingBag,
        title: "E-Commerce Stores",
        description:
            "Sell online with confidence — beautifully designed storefronts with secure checkout.",
    },
    {
        icon: Search,
        title: "SEO Foundation",
        description:
            "Structured for search engines from day one — clean markup, fast loads, and proper metadata.",
    },
    {
        icon: Server,
        title: "Hosting & Maintenance",
        description:
            "Fast, secure managed hosting with ongoing updates, backups, and monitoring built in.",
    },
];

export default function Features() {
    return (
        <section
            id="features"
            data-testid="features-section"
            className="relative py-24 md:py-32 luxe-radial-soft"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                <div className="max-w-3xl mb-20">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="gold-rule-solid w-10" />
                        <span className="text-[11px] uppercase tracking-[0.35em] text-[#D4AF37] font-semibold">
                            Everything You Need
                        </span>
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-white">
                        A partner that handles the{" "}
                        <span className="italic text-gold-metallic">
                            entire website
                        </span>{" "}
                        — so you don&apos;t have to.
                    </h2>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#D4AF37]/10">
                    {features.map((f, idx) => {
                        const Icon = f.icon;
                        return (
                            <div
                                key={f.title}
                                data-testid={`feature-${idx + 1}`}
                                className="group relative bg-black p-8 md:p-10 hover:bg-[#0A0A0A] transition-all duration-500 overflow-hidden"
                            >
                                <div className="absolute -top-20 -right-20 w-48 h-48 rounded-full bg-[#D4AF37]/0 group-hover:bg-[#D4AF37]/10 blur-3xl transition-all duration-700" />

                                <div className="relative">
                                    <div className="w-12 h-12 border border-[#D4AF37]/40 flex items-center justify-center mb-8 group-hover:border-[#D4AF37] group-hover:bg-[#D4AF37]/[0.05] transition-all duration-500">
                                        <Icon
                                            className="w-5 h-5 text-[#D4AF37]"
                                            strokeWidth={1.25}
                                        />
                                    </div>

                                    <h3 className="font-display text-2xl md:text-[26px] text-white mb-3 leading-tight">
                                        {f.title}
                                    </h3>
                                    <p className="text-sm leading-relaxed text-[#888] font-light">
                                        {f.description}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
